import { useMemo } from 'react';
import type { ReactNode } from 'react';

import { FieldErrorContext } from './useFieldError';

/**
 * Supplies the selected element's refusals to every field beneath it.
 *
 * The context and the hook live in `useFieldError` rather than here: a file
 * that exports both a component and a plain function loses fast refresh, which
 * is the same reason `DraftProvider` and `useDraftContext` are two files.
 */
export function FieldErrorProvider({
  errors,
  onResolve,
  children,
}: {
  errors: Record<string, string>;
  onResolve?: (field: string) => void;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ errors, onResolve }), [errors, onResolve]);
  return (
    <FieldErrorContext.Provider value={value}>
      {children}
    </FieldErrorContext.Provider>
  );
}
